import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIonicComponent } from './simple-icons-ionic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIonicComponent ],
    exports:      [ SimpleIconsIonicComponent ],
    bootstrap:    []
})
export class SimpleIconsIonicModule {}
